type UnavailabilitiesFilter = {
  startDate: string;
  endDate: string;
};

const unavailabilitiesFilter: UnavailabilitiesFilter = {
  startDate: "",
  endDate: "",
};

export type { UnavailabilitiesFilter };

export { unavailabilitiesFilter };
